import ReactDOM from "react-dom";
import Backdrop from "../common/modal/Backdrop";
import Modal from "../common/Modal";

import classes from './SystemAlerts.module.css'
import { useSelector } from "react-redux";
import ModalInnerWrapper from "../common/ModalInnerWrapper";
import SystemAlertsItemV2 from "./SystemAlertsItemV2";
import { getItemFromStorageSimple } from "../../lib/script";
import { useState } from "react";

export default function SystemAlerts() {    
    const alerts = useSelector(state => state.system.systemAlerts)    
    const persistentSystemAlerts = getItemFromStorageSimple('persistentSystemAlerts')
    const [rebuild, setRebuild] = useState(0)

    let systemAlerts = alerts ? alerts : persistentSystemAlerts
    function rebuidlHandler() {
        setRebuild(prev => prev+1)
    }
    return <>
        {systemAlerts && systemAlerts.length > 0 && <>
            {ReactDOM.createPortal(
                <Backdrop onTop={true}/>,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal onTop={true}>
                    <ModalInnerWrapper modalTitle={'System Alerts'} mode={'alerts'} setWidth={450}>
                        <div className={classes.container_wrapper}>
                            <div className={classes.container_v2}>
                                {systemAlerts && systemAlerts.map(item => (
                                    <SystemAlertsItemV2 key={item.id} itemData={item} rebuild={rebuidlHandler}/>
                                ))}
                            </div>
                        </div>
                    </ModalInnerWrapper>
                    {/* <div className={classes.container}>
                        {alerts && alerts.map(item => (
                            <SystemAlertsItem key={item.id} itemData={item}/>
                        ))}
                    </div> */}
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}